if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        if (window.trynow) {
          this.boundCartUpdated = () => this.updateTryNowButtonDisabledState();
          document.addEventListener('trynow:cart-updated', this.boundCartUpdated);
        }
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        const productUrl = opener.getAttribute('data-product-url');

        fetch(productUrl)
          .then((response) => response.text())
          .then(async (responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

            // The response can come back without a product section at all — a 404, or a
            // Cloudflare rate-limit / bot-challenge page (HTTP 429, "Verifying your
            // connection"). Without this guard the next line throws inside the promise, the
            // modal never opens, and the button just looks inert. Fall back to the PDP so the
            // shopper still gets to the options they asked for.
            if (!this.productElement) {
              console.warn(`Quick add: no product section in the response for ${productUrl}`);
              window.location.href = productUrl;
              return;
            }

            // Only the section's innerHTML is injected, so the <section> element itself — and the
            // scope class the v2 sections hang their CSS off (main-product-v2, aiw-v2-main-product) —
            // is dropped. Carry its classes onto the modal container so those rules still match.
            // section-*-padding is excluded: its rule body lives in a {% style %} block, so on a PDP
            // it would apply the host section's padding/z-index to the modal's scroll container.
            this.productElement.classList.forEach((classApplied) => {
              if (/^section-.+-padding$/.test(classApplied)) return;
              this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            if (window.trynow) {
              await this.setTryNowQuickBuy();
            }
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            if (window.trynow) {
              this.updateTryNowButtonDisabledState();
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      isTbybItem(item) {
        const name = (item.selling_plan_allocation?.selling_plan?.name) || '';
        return name.indexOf('Try') !== -1;
      }

      updateTryNowButtonDisabledState() {
        const btn = this.modalContent?.querySelector('#trynow_cta_button');
        if (!btn) return;
        const form = btn.closest('form');
        if (!form) return;
        const productIdEl = form.closest('[data-product-id]');
        const productId = productIdEl ? parseInt(productIdEl.getAttribute('data-product-id'), 10) : null;
        if (!productId) return;
        const messageEl = this.modalContent.querySelector('#trynow_cta_already_in_trial');
        if (!messageEl) return;
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            const productIdsInCart = (cart?.items || [])
              .filter((item) => this.isTbybItem(item))
              .map((item) => item.product_id);
            const inCart = productIdsInCart.indexOf(productId) !== -1;
            btn.disabled = inCart;
            messageEl.hidden = !inCart;
          })
          .catch(() => {});
      }

      async setTryNowQuickBuy() {
        const hasPassedTryLink = await window.trynow.hasPassedTryLink()
        const tryNowButton = this.productElement.querySelector('div[id*="trynow_cta_button"]');
        if(tryNowButton) tryNowButton.remove();
        const sellingPlans = this.productElement.querySelector('selling-plans');
        if(sellingPlans) sellingPlans.remove();
        if(hasPassedTryLink){
          const tryNowSellingPlan = (await window.trynow.getSellingPlanId()).split('/').pop()
          if(window.location.href.includes('/collections/try-before-you-buy')) {
            const addToCartButton = this.productElement.querySelector('.product-form__submit')
            if(!addToCartButton) return;
            const tryNowButtonClone = addToCartButton.cloneNode(true);
            tryNowButtonClone.querySelector('.product-form__submit-text').textContent = 'Try Before You Buy';
            tryNowButtonClone.id = 'trynow_cta_button';
            addToCartButton.insertAdjacentElement('afterend', tryNowButtonClone);
            addToCartButton.style.display = 'none';
            const form = addToCartButton.closest('form');
            form.insertAdjacentHTML('afterbegin', `<input type="hidden" name="selling_plan" value="${tryNowSellingPlan}">`);
            const alreadyInTrialEl = document.createElement('p');
            alreadyInTrialEl.id = 'trynow_cta_already_in_trial';
            alreadyInTrialEl.className = 'trynow-cta-modal__already-in-cart';
            alreadyInTrialEl.textContent = 'Already in your trial';
            alreadyInTrialEl.hidden = true;
            alreadyInTrialEl.style.marginTop = '8px';
            alreadyInTrialEl.style.marginBottom = '0';
            alreadyInTrialEl.style.fontSize = '1.2rem';
            alreadyInTrialEl.style.color = '#666';
            alreadyInTrialEl.style.textAlign = 'center';
            tryNowButtonClone.insertAdjacentElement('afterend', alreadyInTrialEl);
          }
        }
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
